import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute, Router } from '@angular/router'

import { MenuItem } from 'primeng/api'

import { Observable, combineLatest } from 'rxjs'
import { tap } from 'rxjs/operators'

import { FlxCardComponent } from '@flowx/angular-ui-toolkit'
import { FlxResourceHeaderComponent } from '@flowx/designer/modules/layout/components/resource-header/resource-header.component'
import { ExceptionDetailsContentComponent } from '@flowx/designer/modules/process/pages/exception-details-content/exception-details-content.component'
import { ProcessException } from '@flowx/designer/shared/entities/process-exceptions.types'
import { ApplicationDetails } from '@flowx/designer/shared/entities/process-instance.types'
import { ProcessExceptionsService } from '@flowx/designer/shared/services/process-exceptions.service'

@Component({
  selector: 'app-exception-details-page',
  templateUrl: './exception-details-page.component.html',
  styleUrls: ['./exception-details-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    FlxResourceHeaderComponent,
    ExceptionDetailsContentComponent,
    FlxCardComponent,
  ],
})
export class ExceptionDetailsPageComponent implements OnInit {
  #router = inject(Router)
  #route = inject(ActivatedRoute)
  #destroyRef = inject(DestroyRef)
  #processExceptionsService = inject(ProcessExceptionsService)

  context$: Observable<{
    processException: ProcessException
    applicationDetails: ApplicationDetails
    loading: boolean
  }>
  breadcrumbs: MenuItem[] = []

  ngOnInit(): void {
    this.#route.params
      .pipe(
        tap((params) => this.#processExceptionsService.getException(params.id)),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe()
    this.context$ = combineLatest({
      processException: this.#processExceptionsService.processException$,
      applicationDetails: this.#processExceptionsService.applicationDetails$,
      loading: this.#processExceptionsService.processExceptionLoading$,
    }).pipe(
      tap(({ processException }) => {
        if (processException) {
          this.breadcrumbs = [
            {
              label: 'Exceptions',
              command: (): void => {
                this.#router.navigate(['../'], { relativeTo: this.#route })
              },
            },
            {
              label: `${processException.processDefinitionName} - ${processException.id}`,
            },
          ]
        }
      })
    )
  }
}
